

export class StatusRequest {


    public productId: number;
    public status: number;

     constructor(statusRequest: any) {
         this.productId = statusRequest.productId || '';
         this.status = statusRequest.status || 0;
     }
 }
